import { BehaviorSubject } from 'rxjs';

export const NavbarSubject = new BehaviorSubject({ color: '#FFFFF' });
